import { makeStyles, TextField } from "@material-ui/core";
import { FormChange } from "@saleor/hooks/useForm";
import { maybe } from "@saleor/misc";
import React from "react";

const useStyles = makeStyles(
  {
    datePicker: {
      marginBottom: 20
    },
    helperText: {
      color: "#EC5D77",
      margin: "3px 0px"
    }
  },
  {
    name: "DatePicker_TimePicker"
  }
);

interface DateTimeRangeProps {
  min?: string;
  max?: string;
}

interface DateTimePickerProps {
  disabled: boolean;
  id: string;
  label: string;
  value: string;
  onChange: FormChange;
  inputProps?: DateTimeRangeProps;
  localError: string;
}

export const TimePicker = ({
  id,
  label,
  value,
  onChange,
  inputProps,
  disabled,
  localError
}: DateTimePickerProps) => {
  const classes = useStyles({});

  const handleChange = e => {
    onChange({
      target: {
        name: e.target.name,
        value: e.target.value
      }
    });
  };

  return (
    <TextField
      id={id}
      name={id}
      label={label}
      type="time"
      value={value}
      InputLabelProps={{
        shrink: true
      }}
      onChange={handleChange}
      fullWidth
      InputProps={{
        inputProps: {
          ...inputProps
        }
      }}
      FormHelperTextProps={{
        className: classes.helperText
      }}
      error={!!localError}
      helperText={maybe(() => localError, null)}
      disabled={disabled}
    />
  );
};

export const DatePicker = ({
  id,
  label,
  value,
  inputProps,
  disabled,
  localError,
  onChange
}: DateTimePickerProps) => {
  const classes = useStyles({});
  const handleChange = e => {
    onChange({
      target: {
        name: e.target.name,
        value: e.target.value
      }
    });
  };

  return (
    <TextField
      id={id}
      name={id}
      label={label}
      type="date"
      value={value}
      InputLabelProps={{
        shrink: true
      }}
      fullWidth
      onChange={handleChange}
      className={classes.datePicker}
      InputProps={{
        inputProps: {
          ...inputProps,
          format: "yyyy-MM-dd"
        }
      }}
      error={!!localError}
      FormHelperTextProps={{
        className: classes.helperText
      }}
      helperText={maybe(() => localError, null)}
      disabled={disabled}
    />
  );
};
